module.exports = __webpack_public_path__ + "img/undo-button.fa158d17.svg";